import FormMixin from '@/mixin/form'
import DateMixin from '@/mixin/date'

import Step1 from './Steps/Step1' 
import Step2 from './Steps/Step2' 
import Step3 from './Steps/Step3' 

import ApiApplication from '@/api/identityProvider/application'
import ApiObject from '@/api/identityProvider/object'
import ApiObjectType from '@/api/identityProvider/object-type'

import ObjectModel from '@/model/identity-provider/object'
import ObjectTypeConstants from '@/constants/controle-acesso/object-type'

export default {  
    mixins: [ FormMixin, DateMixin ], 
    components: {
        "objeto-formulario": Step1,
        "objeto-recurso": Step2,
        "objeto-menu": Step3
    },    
    data(){
        return {
            step: 1,
            lista:{
                formulario: [],
                aplicacao: []
            },
            formulario: new ObjectModel().returnModel(),
            formularioObjectType: null            
        }
    }, 
    computed: {  
        title () {
            return this.$t('Views.ControleAcesso.Formulario.Listar.form-title')
        },
        grupoFormulario(){
            return this.$t('Views.ControleAcesso.Formulario.Editar.passo-formulario')
        },   
        grupoRecurso(){
            return this.$t('Views.ControleAcesso.Formulario.Editar.passo-recurso')
        },       
        grupoMenu(){
            return this.$t('Views.ControleAcesso.Formulario.Editar.passo-menu')
        }                                                        
    },
    methods:{
        async listarTipoObjeto(){
            const resultado = await ApiObjectType.listarPorCodigoUnico(ObjectTypeConstants.formulario).catch(erro => this.showSnackbarError(erro.error));
            if(resultado.success){
                this.$set(this, "formularioObjectType", resultado.data);
            }
        },
        async listarAplicacao(){
            const resultado = await ApiApplication.listar().catch(erro => this.showSnackbarError(erro.error));
            if(resultado.success){
                this.$set(this.lista, "aplicacao", resultado.data);
            }
        },
        async listarObjeto(){
            const resultado = await ApiObject.listarPorTipoObjeto(this.formularioObjectType.id).catch(erro => this.showSnackbarError(erro.error));
            if(resultado.success){
                this.$set(this.lista, "formulario", resultado.data);
            }
        }       
    }    
}